function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { View } from "./View";
import { $ } from "./$Element";
export class Page extends View {
    static createAndHydrate(element) {
        const dataEl = $(element).next("script.__RUNE_DATA__.".concat(this.name, '[data-rune-base-name="Page"]'));
        if (dataEl === null) {
            throw new Error("No __RUNE_DATA__ script found");
        } else {
            var _dataEl_getTextContent;
            const hydration_data = JSON.parse((_dataEl_getTextContent = dataEl.getTextContent()) !== null && _dataEl_getTextContent !== void 0 ? _dataEl_getTextContent : "{}");
            dataEl.remove();
            return new this(hydration_data.data, hydration_data.sharedData, ...hydration_data.args).hydrateFromSSR(element);
        }
    }
    constructor(data, sharedData, ...args){
        super(data, ...args);
        _define_property(this, "sharedData", void 0);
        _define_property(this, "_base_name", void 0);
        this.sharedData = sharedData;
        this._base_name = "Page";
    }
}
